module.exports = __webpack_public_path__ + "static/img/JACK-DALTON.ed9c731.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JACK-DALTON.jpg
// module id = XXYF
// module chunks = 0